import { IStoreState } from "../../../../reducers/types";

export const getFinalizePackageResponse = (state: IStoreState) =>
  state.packagesItineraryReview.finalizePackageResponse;

export const getFinalizePackageCallState = (state: IStoreState) =>
  state.packagesItineraryReview.finalizePackageCallState;
